import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ImageService {
  private error$ = new Subject<string>();
  private termSearch$ = new Subject<string>();

  constructor(private http: HttpClient) {}

  setError(message: string) {
    this.error$.next(message);
  }

  getError(): Observable<string> {
    return this.error$.asObservable();
  }

  setTermSearch(term: string) {
    this.termSearch$.next(term);
  }

  getTermSearch(): Observable<string> {
    return this.termSearch$.asObservable();
  }

  getImagesApi(term: string, currentPage: number = 1): Observable<any> {
    return this.http.get(
      `https://pixabay.com/api/?key=${environment.API_KEY}&q=${term}&image_type=all&pretty=true&per_page=10&page=${currentPage}&min_width=400`
    );
  }
}
